import {useMutation} from '@tanstack/react-query';
import {ExportTrueLawConfirmationRequest} from '../../api/types/exportTrueLaw.type';
import {SaveExportConfirmation} from '../../api/endpoints/exportTrueLawApi';

export const useSaveExportConfirmation = () => {
  return useMutation({
    mutationFn: (payload: ExportTrueLawConfirmationRequest) =>
      SaveExportConfirmation(payload),
  });
};
